import Constants from '../actions/types';

const initialState = {
  adminConfig: {
    configFileDirectory: '',
    autoStartPIXPDQ: true,
    consumerQueueWaitTime: 10,
    dataDirectory: '',
    dateFormat: 'yyyyMMdd',
    instanceName: 'openempi',
    nullValueString: '<NULL>',
    rememberManualClassifications: true,
    sessionDuration: 1800,
    transitiveClosure: true,
    updateNotificationRegistrationEntries: [],
    enableUpdateNotifications: false
  },
  systemConfig: {},
  globalIdentifier: {
    assignGlobalIdentifier: false,
    identifierDomainName: ''
  },
  scheduledTasks: [],
  message: null,
  severity: null
};

const systemConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.SYSTEMCONFIG_GET_SUCCESS: {
      const newState = {
        ...state,
        systemConfig: action.payload,
        message: null
      };

      return newState;
    }

    case Constants.SYSTEMCONFIG_GET_FAILURE: {
      const newState = {
        ...state,
        systemConfig: {},
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.GLOBALIDCONFIG_GET_SUCCESS: {
      const newState = {
        ...state,
        globalIdentifier: action.payload
      };

      return newState;
    }

    case Constants.GLOBALIDCONFIG_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.GLOBALIDCONFIG_SAVE_SUCCESS: {
      const newState = {
        ...state,
        globalIdentifier: action.payload,
        message: 'Saved the Global Identifier configuration successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.GLOBALIDCONFIG_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.GLOBALIDCONFIG_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.ADMINCONFIG_GET_SUCCESS: {
      const adminConfig = transformEnableUpdateNotifications(action);
      const newState = {
        ...state,
        adminConfig: adminConfig
      };

      return newState;
    }

    case Constants.ADMINCONFIG_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.ADMINCONFIG_SAVE_SUCCESS: {
      const adminConfig = transformEnableUpdateNotifications(action);
      const newState = {
        ...state,
        adminConfig: adminConfig,
        message: 'Saved the Miscelaneous settings successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.ADMINCONFIG_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.ADMINCONFIG_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.SCHEDULEDTASKS_GET_SUCCESS: {
      const newState = {
        ...state,
        scheduledTasks: action.payload
      };

      return newState;
    }

    case Constants.SCHEDULEDTASKS_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.SCHEDULEDTASKS_SAVE_SUCCESS: {
      const newState = {
        ...state,
        scheduledTasks: action.payload,
        message: 'Saved the Scheduled Tasks successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.SCHEDULEDTASKS_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.SCHEDULEDTASKS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

const transformEnableUpdateNotifications = action => {
  const enableUpdateNotifications =
    action.payload.updateNotificationRegistrationEntries &&
    action.payload.updateNotificationRegistrationEntries.length > 0
      ? true
      : false;
  const adminConfig = {
    ...action.payload,
    enableUpdateNotifications
  };
  return adminConfig;
};

export default systemConfigReducer;
